import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiHome, FiLayers, FiUsers, FiArrowRight } from 'react-icons/fi';

// Si quieres usar el mismo Header que ya tienes, simplemente importa tu componente Header
// y colócalo dentro de este componente. Asumo que ya lo tienes.
// Si no quieres Header, elimina la línea de import y el <Header />.

const Branding = () => {
    return (
        <>
            <main className="pt-32 pb-20 max-w-6xl mx-auto px-4 sm:px-6">
                {/* Hero */}
                <motion.section
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center max-w-3xl mx-auto mb-16"
                >
                    <h1 className="text-4xl sm:text-5xl md:text-6xl font-black text-[#1C1C1C] leading-tight">
                        Planos <span className="text-[#F26B1D]">inteligentes</span>
                        <br />
                        para tus proyectos
                    </h1>
                    <p className="text-gray-500 text-base sm:text-lg mt-4 max-w-xl mx-auto">
                        Diseños de referencia, asesoría técnica y saneamiento legal.
                        Todo lo que necesitas para construir con confianza.
                    </p>
                    <p className="text-gray-500 text-sm sm:text-base mt-2 max-w-xl mx-auto">
                        Encuentra planos <Link to="/planos-gratis" className="text-[#F26B1D] hover:underline">
                              Planos gratis
                        </Link>
                    </p>
                    <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
                        <Link
                            to="/planos"
                            className="inline-flex items-center gap-2 bg-[#F26B1D] hover:bg-[#E05D1A] text-white font-bold py-3 px-8 rounded-xl transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                        >
                            Explorar planos
                            <FiArrowRight className="text-lg" />
                        </Link>
                        <Link
                            to="/"
                            className="inline-flex items-center gap-2 bg-[#1C1C1C] hover:bg-[#333] text-white font-bold py-3 px-8 rounded-xl transition-all"
                        >
                            Conocer servicios
                        </Link>
                    </div>
                </motion.section>

                {/* Características (solo 3) */}
                <motion.section
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                    className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-16"
                >
                    {[
                        {
                            icon: <FiHome className="text-3xl text-[#F26B1D]" />,
                            title: 'Planos de referencia',
                            desc: 'Modelos arquitectónicos listos para descargar y adaptar a tu terreno.'
                        },
                        {
                            icon: <FiLayers className="text-3xl text-[#F26B1D]" />,
                            title: 'Asesoría profesional',
                            desc: 'Ingenieros y arquitectos colegiados para validar y mejorar tu diseño.'
                        },
                        {
                            icon: <FiUsers className="text-3xl text-[#F26B1D]" />,
                            title: 'Saneamiento legal',
                            desc: 'Trámites de regularización y licencias municipales sin complicaciones.'
                        }
                    ].map((item, idx) => (
                        <div
                            key={idx}
                            className="bg-white p-6 rounded-2xl border border-gray-100 shadow-sm text-center hover:shadow-md transition-shadow"
                        >
                            <div className="flex justify-center mb-3">{item.icon}</div>
                            <h3 className="text-lg font-bold text-[#1C1C1C]">{item.title}</h3>
                            <p className="text-sm text-gray-500 mt-1">{item.desc}</p>
                        </div>
                    ))}
                </motion.section>

                {/* CTA final: invitación a la página principal */}
                <motion.section
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    viewport={{ once: true }}
                    className="text-center bg-gradient-to-br from-[#F26B1D]/10 to-[#F26B1D]/5 rounded-3xl p-8 sm:p-12 border border-[#F26B1D]/20"
                >
                    <h2 className="text-2xl sm:text-3xl font-bold text-[#1C1C1C]">
                        ¿Listo para empezar tu proyecto?
                    </h2>
                    <p className="text-gray-500 mt-2 max-w-lg mx-auto">
                        Explora nuestro catálogo completo de planos y servicios profesionales.
                    </p>
                    <Link
                        to="/planos"
                        className="inline-flex items-center gap-2 mt-6 bg-[#1C1C1C] hover:bg-[#F26B1D] text-white font-bold py-3 px-8 rounded-xl transition-all transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                    >
                        Ir a la página principal
                        <FiArrowRight className="group-hover:translate-x-1 transition-transform" />
                    </Link>
                </motion.section>
            </main>
        </>
    );
};

export default Branding;